/**
 * 
 * 固定租车页面数据
 */
let initState = {
  infoData: {}
}
const fixedCarRentalData = {
    state: {
      infoData: {},
    },
    mutations: {
      setInfoData:(state, data) =>{
        state.infoData = data
      },
      resetFixedCarRentalData (state) {
        Object.keys(state).forEach(key => { state[key] = initState[key]})
      },
    },
    actions: {

    }
}

export default fixedCarRentalData



// WEBPACK FOOTER //
// ./src/store/fixedCarRental.js